import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import { MDBCard, MDBCardBody, MDBCardTitle, MDBRow, MDBCol } from "mdbreact";
import content from "../Helpers/home-content-data";

class HomeCardDeck extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let cards = content.items.map((item, key) => {
      return (
        <MDBCol md="12" key={key} style={{margin:"2px"}}>
          <MDBCard>
            <MDBCardBody style={{ height: "200px", overflowY: "auto" }}>
              <MDBCardTitle style={{ color: "blue" }}>
              
                {item.caption}
              </MDBCardTitle>
              <p style={{textAlign:"justify"}}>
              {/* <MDBCardText style={{textAlign:"justify"}}> */}
              {item.description}
              </p>
              {/* </MDBCardText> */}
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      );
    });
    return (
      <div style={{ padding: "10px" }}>
        <MDBRow>{cards}
        </MDBRow>
        <MDBRow>
        <MDBCol md="12"  style={{margin:"2px"}}>
        <MDBCard>
            <MDBCardBody style={{ height: "200px", overflowY: "auto" }}>
                <MDBCardTitle style={{ color: "blue" }}>
                  Snow Cover
                </MDBCardTitle><p style={{textAlign:"justify"}}>
                Snow is a composite mixture of snow particles, air and water, if
                present. Snow cover, being the second major element of the
                cryosphere, plays a vital role in the climatic system of the
                earth. The spatial variability of snow accumulation is important
                in order to estimate the timing of the snow melt. From
                ahydrological perspective, the effect of snow can be seen
                astemporally disconnecting part of the catchment from theactive
                streamflow network and as introducing a delay between themoment
                when water falls as snow and when it is released from the
                snowpack and contributes to streamflow at the outlet of the
                catchment. At local scales, the spatial variability in both
                snowfall and snow accumulation is governed by the interaction
                among cloud microphysics, atmospheric dynamics, and topographic
                features. These processes make the distribution of snow
                accumulation a complex and dynamic processes.</p>
                <br /><p style={{textAlign:"justify"}}>
                In Himalayas, the annual snowmelt contributes from 10 percent to
                more than 30 percent of the flow of the major river basins such
                as the Indus, the Ganga and the Brahmapautra which originate in
                the Indian Himalayas and flow in to India. The combination of
                seasonal snowmelt and glacial melt plays a key role in river
                hydrology and people living in the foot hills of Himalayas and
                lower plains. Monitoring and measuring snow cover is important
                for hydrological modeling of snowmelt runoff and documenting the
                interannual variability of snow cover is also important for
                climate change studies and greater understanding of
                climate-cryosphere interactions. Satellite remote sensing is
                highly useful for mapping snow cover over larger river basins
                and even in inaccessible areas. The repeativity of satellite
                coverage over a region helps in frequent monitoring of snow
                cover extent.</p>
              </MDBCardBody>
            </MDBCard>
            </MDBCol>
            </MDBRow>
       
        
      </div>
    );
  }
}

export default HomeCardDeck;
